if (!customElements.get("product-reviews-badge")) {
  class ProductReviewsBadge extends HTMLElement {
    constructor() {
      super();
      this.setup = this.setup.bind(this);
    }
    connectedCallback() {
      this.setup();
    }

    disconnectedCallback() {
      if (this.mutationObserver) {
        this.mutationObserver.disconnect();
      }
    }

    setup() {
      this.junipWrapper = this.querySelector(".junip-product-summary");
      if (
        this.junipWrapper.querySelector(".junip-product-summary-review-count")
      ) {
        this.render();
      } else if (!this.mutationObserver) {
        this.mutationObserver = new MutationObserver(this.setup);
        this.mutationObserver.observe(this.junipWrapper, {
          attributes: true,
          childList: true,
          subtree: true,
        });
      }
    }

    render() {
      const reviewCountEl = this.junipWrapper.querySelector(
        ".junip-product-summary-review-count"
      );
      const reviewCountText =
        (reviewCountEl && reviewCountEl.textContent.replace(/\D/g, "")) ||
        this.dataset.ratingCount;
      const reviewCount = reviewCountText ? parseInt(reviewCountText, 10) : 0;
      if (reviewCount > 0) {
        this.querySelector(".js-badge-text").textContent =
          reviewCount.toLocaleString() + " REVIEWS";

        if (this.mutationObserver) {
          this.mutationObserver.disconnect();
          this.mutationObserver = null;
        }
      }
    }
  }

  customElements.define("product-reviews-badge", ProductReviewsBadge);
}
